import Rest from './rest';
import axios from 'axios';
import _ from 'lodash';

export default class Email extends Rest {
  static path = 'email';

  static sendToInbox(emailId, userId) {
    return axios.post(`/api/email/${emailId}/deliver/${userId}`);
  }

  static claim(id) {
    return axios.post(`/api/email/${id}/claim`);
  }

  static getFromShort(email) {
    if (_.get(email, 'fromPerson.firstName')) return `${email.fromPerson.firstName} ${email.fromPerson.lastName}`;
  
    // Emails
    if (email.parsedFrom) {
      if (email.parsedFrom.name) return email.parsedFrom.name;
      return email.parsedFrom.local;
    }
  }

  static getFromLong(email) {
    return `${Email.getFromShort(email)} <${email.parsedFrom.address}>`;
  }

  static getLongAddress(address) {
    return address.name ? `${address.name} <${address.address}>` : address.address;
  }

  static getShortAddress(address) {
    return address.name || address.local;
  }
}
